import {Text, type TextProps} from '@dropbox/dig-components/typography';
import cx from 'classnames';
import {OptionalTooltip} from 'components/DSYS/OptionalTooltip';
import {formatCompactMetricValue, getMetricDisplayValue} from 'helpers/compactMetricValue';
import {useMemo} from 'react';

import styles from './CompactMetricValueText.module.css';

type CompactMetricValueTextProps = {
  value?: string | null;
  isBold?: boolean;
  size?: TextProps['size'];
  className?: string;
  wrapperClassName?: string;
  /** When false, only the compact display string is shown (workstream metrics default: true). */
  showTooltip?: boolean;
};

export const CompactMetricValueText = ({
  value,
  isBold,
  size = 'small',
  className,
  wrapperClassName,
  showTooltip = true,
}: CompactMetricValueTextProps) => {
  const compactValue = useMemo(() => {
    const valueText = getMetricDisplayValue(value);
    return formatCompactMetricValue(valueText);
  }, [value]);

  const text = (
    <Text
      size={size}
      isBold={isBold}
      className={cx(showTooltip && compactValue.tooltipValue && styles.valueWithTooltip, className)}
    >
      {compactValue.displayValue}
    </Text>
  );

  if (!showTooltip || !compactValue.tooltipValue) {
    return text;
  }

  return (
    <OptionalTooltip
      enabled
      title={<Text size="small">{compactValue.tooltipValue}</Text>}
      placement="top"
      wrapperClassName={cx(styles.tooltipTrigger, wrapperClassName)}
      wrapperStyle={{width: 'fit-content', maxWidth: '100%'}}
    >
      {text}
    </OptionalTooltip>
  );
};
